import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { IState, EmptyState, IModel } from "./State";
import { Search } from "../../../shared/Search";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    setTab: (tab: number) => void
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IState>, loading: boolean });
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const dt = useRef<any>(null);

    useEffect(() => {
        loadTableData();
    }, [globalFilter, props.reload]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("State_Mast", "GET", null, `filter=${globalFilter}`, props.toast);
        if (response) {
            const data: Array<IState> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyState });
    };

    const openEdit = (rowDatauser: IState) => {
        rowDatauser.country = { country_ID: rowDatauser.country_ID, country_Name: rowDatauser.country_Name };
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                    <Button disabled={tableData.loading} label="Country" className="p-button-secondary mr-2" onClick={() => props.setTab(1)} />
                    <Button disabled={tableData.loading} label="State" className="p-button-info mr-2" onClick={() => props.setTab(2)} />
                    <Button disabled={tableData.loading} label="City" className="p-button-secondary mr-2" onClick={() => props.setTab(3)} />
                </div>
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
            </React.Fragment>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage States</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    const actionBodyTemplate = (rowData: IState) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="state_Name" header="State Name" sortable />
                <Column field="country_Name" header="Country" sortable />
                <Column field="description" header="Description" />
                <Column body={actionBodyTemplate} />
            </DataTable>
        </>
    );
}
